export default __webpack_public_path__ + "507d84f18323252be404db43f9b60919.svg";